module.exports = __webpack_public_path__ + "static/media/programAssessmentRulesTemplate.33de174c.xlsx";